module.exports = __webpack_public_path__ + "static/media/logo_cimb.23270243.svg";